import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
//import AWS from 'aws-sdk';
import awsmobile from "./aws-exports";
import "./index.css";
import App from "./App";

Amplify.configure(awsmobile);

/*
AWS.config.update({
  accessKeyId: 'AKIAUFA3XUE7PDGZVOXR',
  secretAccessKey: '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',
  region: 'ap-south-1',
});
*/

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
